
export function _(str: string) {
    return str;
}